import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useAppContext } from '../appContext';
import { setStorageItem, getStorageItem, removeStorageItem } from '../utils/storage';

  // Save org info
  export const saveInfo = (key:string, data: any) => {
    // Save with 24 hour expiry
    setStorageItem(key, data, 24 * 60 * 60 * 1000);
  };

  // Retrieve payment info
  export const getInfo = (key:string) => {
    return getStorageItem(key);
  };

  export const removeInfo = (key:string)=>{
    return removeStorageItem(key);
  }

interface SignupProps {
  isConference?: boolean;
}

export const Signup: React.FC<SignupProps> = ({ isConference }) => {

  const { auth0,  } = useAppContext();

  
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    // Retrieve parameters
    const param1 = queryParams.get('org'); // "value1"

    if(param1){
      saveInfo('orgInfo',param1);
    }
    else{
      const param2 = queryParams.get('completeActivation');

      if(param2){
        saveInfo('completeActivation',param2);
      }
    }
    if(isConference){
      saveInfo('nsbe',true);
      saveInfo('nsbeprofile', true);
    }
    auth0.loginWithRedirect();
  }, []);

  return <></>;
};

